import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import AppLoader from '../../shared/AppLoader';
import useAPI from '../../utils/api';
import ChatWidgetEditor from './ChatWidgetEditor';
import AiSummaryEditor from './AiSummaryEditor';

export default function WidgetEditor({ site }) {
  const { siteId, widgetId } = useParams();
  const location = useLocation();
  const queryWidgetType = new URLSearchParams(location.search).get('widget_type');
  const API = useAPI();

  const [widgetType, setWidgetType] = useState(queryWidgetType || 'chat');
  const [loading, setLoading] = useState(widgetId !== 'new');

  useEffect(() => {
    if (widgetId !== 'new') {
      const load = async () => {
        const [ok, data] = await API.chatWidgets();
        if (ok && data?.widgets) {
          const w = data.widgets.find(x => x.id.toString() === widgetId);
          if (w) setWidgetType(w.type === 'Widget::AiSummary' ? 'ai_summary' : 'chat');
        }
        setLoading(false);
      };
      load();
    }
  }, [widgetId]);

  if (loading) return <AppLoader visible />;
  if (widgetType === 'ai_summary') return <AiSummaryEditor site={site} />;
  return <ChatWidgetEditor site={site} />;
}
